import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ManagerPackagesSubscriptionsPageRoutingModule } from './manager-packages-subscriptions-routing.module';

import { ManagerPackagesSubscriptionsPage } from './manager-packages-subscriptions.page';
import { SharedComponentsModule } from 'src/app/components/shared-components.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SharedComponentsModule,
    TranslateModule,
    ManagerPackagesSubscriptionsPageRoutingModule
  ],
  declarations: [ManagerPackagesSubscriptionsPage]
})
export class ManagerPackagesSubscriptionsPageModule {}
